import { useGetOrganizationsInfo } from '~hooks/queries/organizations/query';
import useGetIntegratedScrapeStatus from '~hooks/queries/scraping/useGetIntegratedScrapeStatus';
import { useCompanyId } from '~hooks/useCompanyId';

const getLength = (arr?: unknown[]) => {
  return arr?.length || 0;
};

const useGetAnalysisResult = () => {
  const { companyId } = useCompanyId();

  const { data: organizationsInfo, isLoading } = useGetOrganizationsInfo();

  const bankRegistered = organizationsInfo?.Data?.data?.banks.some((bank) => bank.connected);
  const homeTaxRegistered = organizationsInfo?.Data?.data?.homeTax.connected;

  const { data: scrapeStausData } = useGetIntegratedScrapeStatus(companyId as string);
  const scrapeStatus = scrapeStausData?.Data?.data;

  const isAnalysisInprogress = scrapeStatus?.overallStatus === 'IN_PROGRESS';

  const total =
    getLength(scrapeStatus?.bankAccountScrapingStatus) +
    getLength(scrapeStatus?.cashReceiptScrapingStatus) +
    getLength(scrapeStatus?.taxInvoiceScrapingStatus);

  const success =
    getLength(
      scrapeStatus?.bankAccountScrapingStatus.filter((item) => {
        return item.status === 'SUCCESS';
      }),
    ) +
    getLength(
      scrapeStatus?.cashReceiptScrapingStatus.filter((item) => {
        return item.status === 'SUCCESS';
      }),
    ) +
    getLength(
      scrapeStatus?.taxInvoiceScrapingStatus.filter((item) => {
        return item.status === 'SUCCESS';
      }),
    );

  const percentCalculated = Math.floor((success / total) * 100);
  const taxInvoicePercent = scrapeStatus
    ? Math.floor(
        (getLength(
          scrapeStatus?.taxInvoiceScrapingStatus.filter((item) => {
            return item.status === 'SUCCESS';
          }),
        ) /
          getLength(scrapeStatus?.taxInvoiceScrapingStatus)) *
          100,
      )
    : 0;

  const percent = success && total ? (percentCalculated === 100 ? 99 : percentCalculated) : 0;
  const isAnalysisFailed =
    scrapeStatus?.overallStatus === 'ERROR' || scrapeStatus?.overallStatus === 'FATAL';

  const errorCausesMsg = () => {
    const bankErrorExist = scrapeStatus?.bankAccountScrapingStatus?.some(
      (s) => s.status === 'ERROR' || s.status === 'FATAL',
    );

    const cardErrorExist = scrapeStatus?.cardScrapingStatus?.some(
      (s) => s.status === 'ERROR' || s.status === 'FATAL',
    );

    const taxInvoiceErrorExist = scrapeStatus?.taxInvoiceScrapingStatus?.some(
      (s) => s.status === 'ERROR' || s.status === 'FATAL',
    );

    const cashReceiptErrorExist = scrapeStatus?.cashReceiptScrapingStatus?.some(
      (s) => s.status === 'ERROR' || s.status === 'FATAL',
    );

    const securityCodeErrorExist = scrapeStatus?.securityAccountListScrapingStatus?.some(
      (s) => s.status === 'ERROR' || s.status === 'FATAL',
    );

    const errorExist =
      bankErrorExist ||
      cardErrorExist ||
      taxInvoiceErrorExist ||
      cashReceiptErrorExist ||
      securityCodeErrorExist;

    const errorObj = {
      bank: bankErrorExist ? '은행 계좌' : '',
      security: securityCodeErrorExist ? '증권 계좌' : '',
      card: cardErrorExist ? '카드' : '',
      taxInvoice: taxInvoiceErrorExist ? '세금계산서' : '',
      cashReceipt: cashReceiptErrorExist ? '현금영수증' : '',
    };

    const errorMsg = Object.values(errorObj)
      .filter((v) => v)
      .join(', ');

    return errorExist ? errorMsg : '은행 계좌 / 카드 / 세금계산서 / 현금영수증';
  };

  return {
    isAnalysisInprogress,
    percent,
    organizationsInfo,
    isAnalysisFailed,
    bankRegistered,
    homeTaxRegistered,
    errorCausesMsg,
    taxInvoicePercent,
  };
};

export default useGetAnalysisResult;
